export default __webpack_public_path__ + "static/media/vehicleIcon.033b524c.svg";